import React from "react";

import BasicNavbar from "./BasicNavbar";
import PricingSection from "./PricingSection";
import SiteFooter from "../../components/SiteFooter";

export default function PricePage() {
  return (
    <div className="dark">
      <div
        className="bg-background relative flex min-h-screen min-h-dvh w-full flex-col overflow-x-hidden scroll-smooth"
        style={{ ["--navbar-height" as string]: "60px" } as React.CSSProperties}
      >
        <BasicNavbar />
        <main className="relative z-10 flex w-full flex-1 flex-col pt-[calc(var(--navbar-height)+var(--intl-notice-height,0px))]">
          <PricingSection />
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}
